import { createContext, useContext } from 'react'

export const sidebarWidthContext = createContext<{
  sidebarWidth: number
}>({
  sidebarWidth: 0,
})

export const SidebarWidthProvider = sidebarWidthContext.Provider

export const useSidebarWidth = () => {
  const context = useContext(sidebarWidthContext)
  return context
}
